import { render } from "./PTextFieldLegado.vue?vue&type=template&id=f27f6314&scoped=true&lang=pug"
import script from "./PTextFieldLegado.vue?vue&type=script&lang=js"
export * from "./PTextFieldLegado.vue?vue&type=script&lang=js"

import "./PTextFieldLegado.vue?vue&type=style&index=0&id=f27f6314&scoped=true&lang=scss"
import "./PTextFieldLegado.vue?vue&type=style&index=1&id=f27f6314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27f6314"],['__file',"src/common/inputs/PTextFieldLegado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f27f6314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f27f6314', __exports__)) {
    api.reload('f27f6314', __exports__)
  }
  
  module.hot.accept("./PTextFieldLegado.vue?vue&type=template&id=f27f6314&scoped=true&lang=pug", () => {
    api.rerender('f27f6314', render)
  })

}


export default __exports__